import { calendarScheduleInterviewConstants } from "../../_constants";
import axiosInstance from "../../../_helpers/axiosInstance";
import config from "../../../_config/config";

//schedule interview
export const schedule_interview_request_action = (data) => async (dispatch) => {
  dispatch({
    type: calendarScheduleInterviewConstants.SCHEDULE_INTERVIEW_REQUEST_ACTION_REQUEST,
  });
  try {
    const response = await axiosInstance.post(
      config.common.requestScheduleInterview,
      data
    );
    if (response.status) {
      dispatch({
        type: calendarScheduleInterviewConstants.SCHEDULE_INTERVIEW_REQUEST_ACTION_SUCCESS,
        payload: response.data,
      });
      return response.data;
    } else {
      return false;
    }
  } catch (e) {
    dispatch({
      type: calendarScheduleInterviewConstants.SCHEDULE_INTERVIEW_REQUEST_ACTION_FAILURE,
      payload: e.msg,
    });
  }
};

//schedule interview
export const schedule_interview_request_detail_action =
  (id) => async (dispatch) => {
    dispatch({
      type: calendarScheduleInterviewConstants.GET_SCHEDULE_INTERVIEW_REQUEST_DETAIL_ACTION_REQUEST,
    });
    try {
      const response = await axiosInstance.get(
        config.common.requestScheduleInterviewById.replace(":id", id)
      );
      if (response.status) {
        dispatch({
          type: calendarScheduleInterviewConstants.GET_SCHEDULE_INTERVIEW_REQUEST_DETAIL_ACTION_SUCCESS,
          payload: response.data,
        });
        return response.data;
      } else {
        return false;
      }
    } catch (e) {
      dispatch({
        type: calendarScheduleInterviewConstants.GET_SCHEDULE_INTERVIEW_REQUEST_DETAIL_ACTION_FAILURE,
        payload: e.msg,
      });
    }
  };

//schedule interview
export const get_scheduled_interview_detail_action =
  (id) => async (dispatch) => {
    dispatch({
      type: calendarScheduleInterviewConstants.GET_SCHEDULED_INTERVIEW_DETAIL_ACTION_REQUEST,
    });
    try {
      const response = await axiosInstance.get(
        config.common.requestScheduleInterviewById.replace(":id", id)
      );
      if (response.status) {
        dispatch({
          type: calendarScheduleInterviewConstants.GET_SCHEDULED_INTERVIEW_DETAIL_ACTION_SUCCESS,
          payload: response.data,
        });
        return response.data;
      } else {
        return false;
      }
    } catch (e) {
      dispatch({
        type: calendarScheduleInterviewConstants.GET_SCHEDULED_INTERVIEW_DETAIL_ACTION_FAILURE,
        payload: e.msg,
      });
    }
  };

//schedule interview
export const unregistered_user_schedule_interview_request_action =
  (data) => async (dispatch) => {
    dispatch({
      type: calendarScheduleInterviewConstants.UNREGISTERED_USER_SCHEDULE_INTERVIEW_REQUEST_ACTION_REQUEST,
    });
    try {
      const response = await axiosInstance.post(
        config.common.unregisteredUserRequestScheduleInterview,
        data
      );
      if (response.status) {
        dispatch({
          type: calendarScheduleInterviewConstants.UNREGISTERED_USER_SCHEDULE_INTERVIEW_REQUEST_ACTION_SUCCESS,
          payload: response.data,
        });
        return response.data;
      } else {
        return false;
      }
    } catch (e) {
      dispatch({
        type: calendarScheduleInterviewConstants.UNREGISTERED_USER_SCHEDULE_INTERVIEW_REQUEST_ACTION_FAILURE,
        payload: e.msg,
      });
    }
  };

//schedule interview
export const unregistered_user_schedule_interview_request_detail_action =
  (id) => async (dispatch) => {
    dispatch({
      type: calendarScheduleInterviewConstants.UNREGISTERED_USER_GET_SCHEDULE_INTERVIEW_REQUEST_DETAIL_ACTION_REQUEST,
    });
    try {
      const response = await axiosInstance.get(
        config.common.unregisteredUserRequestScheduleInterviewbyId.replace(
          ":id",
          id
        )
      );
      if (response.status) {
        dispatch({
          type: calendarScheduleInterviewConstants.UNREGISTERED_USER_GET_SCHEDULE_INTERVIEW_REQUEST_DETAIL_ACTION_SUCCESS,
          payload: response.data,
        });
        return response.data;
      } else {
        return false;
      }
    } catch (e) {
      dispatch({
        type: calendarScheduleInterviewConstants.UNREGISTERED_USER_GET_SCHEDULE_INTERVIEW_REQUEST_DETAIL_ACTION_FAILURE,
        payload: e.msg,
      });
    }
  };


